import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const MissionAccountingPage_AccountingInfo_Fragment = graphql(`
  fragment MissionAccountingPage_AccountingInfo_Fragment on AccountingInfo {
    _id
    stateId
    workflowId
  }
`);

export type MissionAccountingPage_AccountingInfo = ResultOf<
  typeof MissionAccountingPage_AccountingInfo_Fragment
>;
